export { default as default } from './EventService';
